import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 热冷游戏组件类 */
export class HotColdGameComponent extends BaseComponent<BaseComponentAttrs> {
  constructor(data: Partial<BaseComponent<BaseComponentAttrs>> = {}) {
    super(data);
    this.type = CompType.hot_cold_game;
  }
}
